var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fuel-utilization page__container--no-padding" },
    [
      _vm.loaders.filters
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Filters", {
        attrs: { "filters-shown": "['dateRange', 'workOrderParams']" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "panel panel--shaded grid" }, [
        _c("div", { staticClass: "grid__col--5" }),
        _vm._v(" "),
        _c("div", { staticClass: "grid__col--2 h-center-align" }, [
          _c(
            "button",
            {
              staticClass:
                "btn btn-primary btn-block fuel-utilization__search-submit",
              attrs: { disabled: _vm.loaders.dateList },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.update($event)
                }
              }
            },
            [_vm._v("Search")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "grid__col--5" })
      ]),
      _vm._v(" "),
      _vm.workOrders.length
        ? _c("div", { staticClass: "fuel-utilization-wo__container" }, [
            _c(
              "div",
              { staticClass: "grid fuel-utilization__search-container" },
              [
                _c("div", { staticClass: "grid__col--9" }),
                _vm._v(" "),
                _c("div", { staticClass: "grid__col--3" }, [
                  _c(
                    "div",
                    { staticClass: "fuel-utilization__search-container-input" },
                    [
                      _c("StoreConnectedSearch", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.workOrders.length,
                            expression: "workOrders.length"
                          }
                        ],
                        attrs: { store: "fuelUtilization", name: "search" }
                      })
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "fuel-util-wo-container" } },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "fuel-utilization__nav-container is-hidden-mobile"
                  },
                  [
                    _c(
                      "Affix",
                      {
                        staticClass: "fuel-utilization__nav",
                        attrs: {
                          "relative-element-selector":
                            "#fuel-util-wo-container",
                          offset: { top: 71, bottom: 0 }
                        }
                      },
                      [
                        _vm._l(_vm.statusesList, function(status, index) {
                          return _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "smooth-scroll",
                                  rawName: "v-smooth-scroll",
                                  value: { duration: 500, offset: -150 },
                                  expression: "{duration: 500, offset: -150}"
                                }
                              ],
                              key: index,
                              staticClass: "fuel-utilization__nav-item",
                              attrs: { href: _vm.anchorName(status) }
                            },
                            [_vm._v(_vm._s(status))]
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.statusesList, function(status, index) {
                  return _c("StatusGroup", {
                    key: index,
                    staticClass: "fuel-utilization-wo",
                    attrs: {
                      status: status,
                      "work-orders": _vm.workOrderObject[status]
                    }
                  })
                })
              ],
              2
            )
          ])
        : _c("div", { staticClass: "fuel-utilization-wo__container" }, [
            _c("div", { staticClass: "fuel-utilization__no-data" }, [
              _vm.loaders.workOrders
                ? _c("div", [_c("MoonLoader", { attrs: { size: "75px" } })], 1)
                : _vm.filtersChanged
                ? _c("div", [
                    _vm._v(
                      "Please run a new report to apply the current filter settings"
                    )
                  ])
                : _c("div", [_vm._v("You have no current work orders.")])
            ])
          ]),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "btn-back-to-top", attrs: { href: "#top" } },
      [_c("i", { staticClass: "fa fa-chevron-up" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }